<template>
	<div class="cat_group flex flex--start" v-if="products">

    <template v-for="(product, index) in products">
			<template
				v-if="
					inlinePromotionsLocations.indexOf(index) >= 0 &&
						inlinePromotions[inlinePromotionsLocations.indexOf(index)]
				"
			>
				<InlinePromotion
					:promo="inlinePromotions[inlinePromotionsLocations.indexOf(index)]"
					:home_url="home_url"
					:assets="assets"
				/>
				<p style="display: none">{{ index++ }}</p>
			</template>

			<template v-if="product">
				<Product
					ref="productComponent"
					v-bind:category="category"
					v-bind:product="product"
					v-bind:index="index"
					:key="product.id"
					:index="index"
					:data-index="index"
				></Product>
			</template>
		</template>

		<div
			class="sorry_row center"
			style="margin: 0 auto"
			v-if="allPageLoaded && products != 'undefined' && products.length == 0"
		>
			<div class="sorry_img">
				<img :src="assets + '/layout/sorry.png'" />
			</div>
			<div class="title25 bold">
				איזה באסה, אין לנו כאן את המוצרים שחיפשת....
			</div>
			<div class="text">
				אבל יש לנו עוד הרבה מוצרים אחרים שיוכלו למלא לך את העגלה בטוב
			</div>
			<div class="inline clearfix">
				<div class="right bt_green ease" v-if="sale">
					<a-div :href="globalOptions.all_sale_products_link.replace(home_url, '')">לכל המוצרים במבצע</a-div>
				</div>
				<div class="right bt_green ease" v-if="organic">
					<a-div :href="globalOptions.all_organic_products_link.replace(home_url, '')"
						>לכל המוצרים האורגניים</a-div
					>
				</div>
				<div class="right bt_green ease" v-if="glutenfree">
					<a-div :href="globalOptions.all_gluten_free_link.replace(home_url, '')"
						>לכל המוצרים ללא גלוטן</a-div
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Product from "./Product/Product";
	import InlinePromotion from "./InlinePromotion.vue";
	export default {
		props: [
			"items",
			"numofproducts",
			"category",
			"sale",
			"organic",
			"glutenfree",
			"winered",
			"vegan",
			"winewhite",
			"wineroze",
			"index",
			"showAllProducts",
			"allPageLoaded",
			"inlinePromotions"
		],

		name: "ProductsRow",
		data() {
			return {
				assets: wpData.assets_url,
				home_url: wpData.home_url,
				globalOptions: wpData.globalOptions,
				loadingProducts: false,
				loaderGif: wpData.assets_url + "/layout/loader.gif",
				inlinePromotionsLocations: [9, 20, 27, 38, 45],
				currentInlinePromotion: 0
			};
		},
		watch: {
			numofproducts(value) {
				if (typeof this.items != "undefined" && value >= this.items.length) {
					this.$root.$emit("nextCategory", { index: this.index });
				}
			}
		},
		mounted() {
			if (typeof this.items != "undefined" && this.numofproducts >= this.items.length) {
				this.$root.$emit("nextCategory", { index: this.index });
			}
		},
		computed: {
			products() {
				if (this.items) {
					this.loadingProducts = true;
					var productsFound = this.items;

					const filters = this.$store.state.productFilters;

					filters.forEach(filter => {
						if (filter.isActive) {
							productsFound = filter.fn(productsFound);
						}
					});

					this.loadingProducts = false;
					if (this.sale || this.glutenfree || this.organic || this.winered || this.winewhite || this.vegan) {
						return productsFound;
					}
					if (this.showAllProducts) {
						return productsFound;
					}
					return productsFound.slice(0, parseInt(this.numofproducts));
					//return this.items.slice(0,parseInt(this.numofproducts));
				}
				return {};
			}
		},
		components: {
			Product,
			InlinePromotion
		}
	};
</script>
